import { ToastService, ToastConfig, ToastOptions, ToastData } from '../../common/toasts';
import { JobsNotifierService } from './job-notifier.service';

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { JobConstants } from '../../common/utils/job-constants';

@Injectable()
export class ToastNotifierService {

    private subscription: any;
    private runningJobsSubscription: any;

    constructor(public toastService: ToastService, public jobNotifierService: JobsNotifierService) {
        this.subscription = this.jobNotifierService.getCompletedJobs().subscribe(jobs => {
                this.pushToasts(jobs);
            },
            error => {},
            () => {}
        );
        this.runningJobsSubscription = this.jobNotifierService.getRunningJobs().subscribe(jobs => {
                this.pushRunningToasts(jobs);
            },
            error => {},
            () => {}
        );
    }

    pushToasts(jobs) {
        for ( let job of jobs ) {
            if ( job ) {
                if(JobConstants.getServiceToExcludeFromToast().indexOf(job.jobType) === -1){
                    let toastOptions = this.newToast(job);
                    if ( job.hasOwnProperty('didFail') ) {
                        if ( job.didFail ) {
                            this.toastService.error(toastOptions);
                        } else {
                            this.toastService.success(toastOptions);
                        }
                    } else {
                        this.toastService.default(toastOptions);
                    }
                }
            }
        }
    }

    pushRunningToasts(jobs) {
        for ( let job of jobs ) {
            if ( job ) {
                if(JobConstants.getServiceToExcludeFromToast().indexOf(job.jobType) === -1){
                    let toastOptions = this.newToast(job);
                    this.toastService.info(toastOptions);
                }
            }
        }
    }

    newToast(job) {
        let toastOptions: ToastOptions = {
            title: job.entityName,
            msg: job.description,
            showClose: true,
            timeout: 9000,
            theme: 'default',
            onAdd: (toast: ToastData) => {
            },
            onRemove: function(toast: ToastData) {
            }
        };
        return toastOptions;
    }

    ngOnDestroy() {
        if ( this.subscription ) this.subscription.unsubscribe();
        if ( this.runningJobsSubscription ) this.runningJobsSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/toast-notifier.service.ts